import type { ContactType } from './types';

export const CONTACT_MODAL_POPCONFIRM_WIDTH = '240px';

export const CLIENT_CONTACT_TYPES: readonly ContactType[] = [
  'Seller',
  'Tenant',
  'Landlord/Manager',
  'Buyer',
];
